/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  BadRequestErrorResponse,
  NotFoundErrorResponse,
  PostApiSignUpComplete200,
  SignUpStartRequest
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type postApiSignUpCompleteResponse200 = {
  data: PostApiSignUpComplete200
  status: 200
}

export type postApiSignUpCompleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiSignUpCompleteResponseSuccess = (postApiSignUpCompleteResponse200) & {
  headers: Headers;
};
export type postApiSignUpCompleteResponseError = (postApiSignUpCompleteResponse404) & {
  headers: Headers;
};

export type postApiSignUpCompleteResponse = (postApiSignUpCompleteResponseSuccess | postApiSignUpCompleteResponseError)

export const getPostApiSignUpCompleteUrl = (hash: string,) => {


  

  return `/api/sign-up/complete/${hash}`
}

export const postApiSignUpComplete = async (hash: string, options?: RequestInit): Promise<postApiSignUpCompleteResponse> => {
  
  return customFetch<postApiSignUpCompleteResponse>(getPostApiSignUpCompleteUrl(hash),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


export type postApiSignUpStartResponse204 = {
  data: void
  status: 204
}

export type postApiSignUpStartResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}
    
export type postApiSignUpStartResponseSuccess = (postApiSignUpStartResponse204) & {
  headers: Headers;
};
export type postApiSignUpStartResponseError = (postApiSignUpStartResponse400) & {
  headers: Headers;
};

export type postApiSignUpStartResponse = (postApiSignUpStartResponseSuccess | postApiSignUpStartResponseError)

export const getPostApiSignUpStartUrl = () => {


  

  return `/api/sign-up/start`
}

export const postApiSignUpStart = async (signUpStartRequest: SignUpStartRequest, options?: RequestInit): Promise<postApiSignUpStartResponse> => {
  
  return customFetch<postApiSignUpStartResponse>(getPostApiSignUpStartUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      signUpStartRequest,)
  }
);}


